import {
  getCheckoutLineItems,
  setRemoveLineItemInCart,
  setUpdateQuantityInCart,
} from "@/util/utils";
import { create } from "zustand";

export const useAppCommonStore = create((set, get) => ({
  checkout: { checkout: { lineItems: [] } },
  openModal: false,
  setOpenModal: (value: boolean) => set(() => ({ openModal: value })),
  setCheckout: (res: any) => set(() => ({ checkout: res })),
  selectedCountry: { label: "United Kingdom", value: "en-GB" },
  setSelectedCountry: (value: any) =>
    set(() => ({ selectedCountry: value })),

  updateQuantityInCart: async (
    lineItemId: string,
    quantity: number
  ) => {
    const { selectedCountry }: any = get();
    const countryCode = selectedCountry.value;

    const lineItemsToUpdate = [
      { id: lineItemId, quantity: parseInt(quantity as any, 10) },
    ];

    const res = await setUpdateQuantityInCart(
      lineItemsToUpdate,
      countryCode
    );
    set(() => ({ checkout: res }));
  },

  removeLineItemInCart: async (lineItemId: any) => {
    const { selectedCountry }: any = get();
    const countryCode = selectedCountry.value;
    const res = await setRemoveLineItemInCart(
      lineItemId,
      countryCode
    );
    set(() => ({ checkout: res }));
  },

  toggleCartSidebar: async () => {
    const { openModal, selectedCountry }: any = get();
    const countryCode = selectedCountry.value;
    if (countryCode) {
      if (!openModal) {
        const res = await getCheckoutLineItems(countryCode);
        set(() => ({ checkout: res, openModal: !openModal }));
      } else {
        set(() => ({ openModal: !openModal }));
      }
    }
  },
}));
